import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { SellerDepositAppLogBo, SellerDepositAppLogVo, SellerDepositDetailVo } from './types';
/**
 * 保证金退款
 */
export const sellerDepositRefund = () => {
  return request({
    url: '/member/app/sellerDeposit/refund',
    method: 'post'
  });
};

/**
 * 保证金变更列表
 */
export const sellerDepositLogList = (params: SellerDepositAppLogBo): AxiosPromise<SellerDepositAppLogVo[]> => {
  return request({
    url: '/member/app/sellerDeposit/logList',
    method: 'get',
    params
  });
};

/**
 * 保证金详情
 */
export const sellerDepositDetail = (): AxiosPromise<SellerDepositDetailVo> => {
  return request({
    url: '/member/app/sellerDeposit/detail',
    method: 'get'
  });
};
/**
 * 保证金退款检查
 */
export const sellerDepositRefundCheck = () => {
  return request({
    url: '/member/app/sellerDeposit/refund/check',
    method: 'post'
  });
};
